import React from 'react';
import FlexibleTable from '@/stories/Components/FlexibleTable/FlexibleTable';
import { useTranslations } from 'use-intl';
import { toTranslationKey } from '@/utils/translations';
import { CreditBureauCreditScore } from '@/graphql/__generated__/onboarding';
import ExpandableTable from './ExpandableTable';

interface ScoreProps {
	score?: CreditBureauCreditScore[] | null;
}

const Score: React.FC<ScoreProps> = ({ score }) => {
	const t = useTranslations('CreditBureau');
	if (!score || score.length === 0) return null;

	// Create a new object with translated keys
	const translatedData = Object.entries(score[0])
		.filter(([key]) => key !== '__typename')
		.reduce(
			(acc, [key, value]) => {
				const translatedKey = t(toTranslationKey(key));
				acc[translatedKey] = value;
				return acc;
			},
			{} as Record<string, any>
		);

	return (
		<ExpandableTable title={t('Score')}>
			<div className="max-w-4xl">
				<FlexibleTable flipped data={translatedData} />
			</div>
		</ExpandableTable>
	);
};

export default Score;
